import React from 'react'
import IncomeContainer from './Income.container'
import IncomeUI from './Income.UI'
import PrivatePage from '../../../components/PrivatePage'
import EmptyState from '../../EmptyState'
import WalletIcon from '../../../components/Images/WalletIcon'

const Income = props => {
  return (
    <PrivatePage>
      <IncomeContainer {...props}>
        <IncomeUI />
        {/* <EmptyState 
          text='Sorry, Income page is under Maintenance' 
          subText="Don't worry our team is working hard to pay authors before 8th of every month for the approved books according to the writers benefit program" 
          image={WalletIcon}/> */}
      </IncomeContainer>
    </PrivatePage>
  )
}

export default Income
